<template>
	<div style="height:100%;display:flex;flex-direction:column;overflow:hidden;position:relative;width:100%">
		<!-- 顶部栏 -->
		<el-button class="show-on-mobile student-btn-right-icon" size=""
			style="width: 30px;right: 0%;position: absolute;height: 30px;margin-top: 100px;z-index: 1000;"
			type="success" @click="showStudentDrawer = true">
			<i class="el-icon-user" style="font-size: 20px;"></i>
		</el-button>
		<div :style="{ width: isMobile ? '100%' : '60%' }" style="
				    position: fixed; 
				    top: 0; 
				    left: 0; 
				    right: 0; 
				    margin: 0 auto; 
				    width: fit-content; 
				    
				     background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); 
				    color:#fff; 
				    padding: 8px 24px; 
				    border-radius: 0 0 12px 12px; 
				    display: flex; 
				    justify-content: center; 
				    align-items: center; 
				    z-index: 9999;
				  ">
			<ClassInformation :courseName="courseName" :teacherName="teacherName" :isSave="isSave"
				:onlineCount="totalData.onlineCount || 0" />
		</div>

		<!-- 左侧学生列表（PC端显示） -->
		<div class="left-sidebar"
			style="position:absolute;left:0;top:0;bottom:0;width:380px;background:#f5f7fa;padding:16px;overflow-y:auto;z-index:5">
			<StudentList :student-list="studentList" :total-data="totalData" :current-student-id="currentStudentId"
				:isSave="isSave" :course-class-id="courseClassId" :school-id="schoolId" :teacher-id="teacherId"
				@select-student="selectStudent" @lock-student="lockStudent" @send-praise="sendPraise"
				@cancel-praise="cancelPraise" />
		</div>

		<!-- 右侧聊天区域（纯设备判断，和抽屉无关） -->
		<div style="position:absolute; top:0; right:0; bottom:0; z-index:4; overflow:hidden; transition: left 0.3s ease;"
			:style="{ left: isMobile ? '0px' : '380px' }">
			<StudentChat v-if="customPageId==0" :currentStudentId="String(currentStudentId)"
				:currentStudentName="currentStudentName" :isSave="isSave" :chatList="chatList" :schoolId="schoolId"
				:courseClassId="courseClassId" :teacherId="teacherId" @update-chat-list="chatList = $event"
				@append-chat-list="chatList = [...chatList, ...$event]" @refresh-student-list="getStudentList" />
			<StudentInde :key="studentId" ref="studentInde" v-if="currentStudentId!=''" v-show="customPageId!=0"
				:studentId="String(currentStudentId)" :courseClassId="courseClassId" />
		</div>

		<el-drawer :visible.sync="showStudentDrawer" direction="rtl" size="80%" :modal-append-to-body="false"
			:append-to-body="false" :modal="false" title="班级学生" style="z-index:30003 !important;">
			<!-- 👇 这一层就是用来“关住”子组件的 👇 -->
			<div style="
				    display: block;
				    width: 100%;
				    height: 100%;
					min-width:280px;
				    position: relative;
				    overflow: hidden;
					margin-left: 10px;
				  ">
				<StudentList :student-list="studentList" :total-data="totalData" :current-student-id="currentStudentId"
					:course-class-id="courseClassId" :school-id="schoolId" :teacher-id="teacherId"
					@select-student="selectStudent" @lock-student="lockStudent" @send-praise="sendPraise"
					@cancel-praise="cancelPraise" :isSave="isSave" />
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import StudentChat from './classRoom/StudentChat.vue'
	import ClassInformation from './classRoom/ClassInformation.vue'
	import StudentList from './classRoom/studentList.vue'
	import StudentInde from '@/views/student/test 1/index.vue'
	export default {
		components: {
			StudentChat,
			ClassInformation,
			StudentList,
			StudentInde
		},
		data() {
			return {
				showStudentDrawer: false,
				isMobile: false,
				resizeTimer: null,
				schoolId: localStorage.getItem('orgId'),
				teacherId: localStorage.getItem('userId'),
				courseClassId: localStorage.getItem('courseClassId'),
				courseName: localStorage.getItem('courseName'),
				teacherName: localStorage.getItem('nickName'),
				studentList: [],
				currentStudentId: '',
				studentId:'',
				currentStudentName: '',
				chatList: [],
				timer: null,
				statusTimer: null,
				totalData: {},
				loading: true,
				isSave: true,
				courseId:'',
				customPageId: localStorage.getItem('customPageId')||'',
			}
		},
		created() {
			const ticket = this.$route.query.ticket;
			const token = localStorage.getItem('token');
			const base = process.env.BASE_URL;

			// --------------------------
			// 关键修复：
			// 1. 先清掉旧 token，避免干扰
			// 2. 有 ticket 必须先走免登，不判断本地 token
			// --------------------------
			if (ticket) {
				// 先清旧 token，防止冲突
				localStorage.removeItem('token');
				this.initWatchUser(ticket);
				return;
			}

			// 没有 ticket 才走正常登录逻辑
			if (token) {
				window.history.replaceState({}, '', base + '#' + this.$route.path);
				this.initPage();
				return;
			}

			// 都没有才报错
			this.$message.error('无效链接');
		},
		mounted() {
			window.addEventListener('resize', this.handleWindowResize)
			this.handleWindowResize() // 页面加载时自动判断设备类型
		},
		beforeDestroy() {
			if (this.timer) clearInterval(this.timer)
			if (this.statusTimer) clearInterval(this.statusTimer)
			if (this.resizeTimer) clearTimeout(this.resizeTimer)
			window.removeEventListener('resize', this.handleWindowResize)
		},
		methods: {
			sendPraise() {

			},
			lockStudent() {

			},
			cancelPraise() {

			},
			handleWindowResize() {
				if (this.resizeTimer) clearTimeout(this.resizeTimer)

				this.resizeTimer = setTimeout(() => {
					this.isMobile = window.innerWidth <= 1024
				}, 300)
			},
			initWatchUser(ticket) {
				this.API.get(this.API.school.getCheckWatchTicket + `?ticket=${ticket}`).then(res => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '已过期')
						return
					}
					var d = res.data.data
					// 存登录信息
					localStorage.setItem('token', d.token)
					this.teacherId = d.userId
					localStorage.setItem('customPageId', d.customPageId)
					localStorage.setItem('isSave', true)
					this.schoolId = d.orgId
					this.customPageId=d.customPageId
					localStorage.setItem('userId', d.userId)
					localStorage.setItem('userType', d.userType)
					localStorage.setItem('orgId', d.orgId)
					this.courseClassId = d.courseClassId
					this.courseName = `${d.courseName}--授课教师:${d.teacherName}`
					localStorage.setItem('courseName', this.courseName)
					localStorage.setItem('courseClassId', this.courseClassId)
					if(d.courseId){
						localStorage.setItem('courseId', d.courseId)
						this.courseId=d.courseId
					}
					
					
					// --------------------------
					// 👇 这里必须加！清除 URL 里的 ticket
					// --------------------------
					const base = process.env.BASE_URL
					window.history.replaceState({}, '', base + '#' + this.$route.path)

					this.initPage()

				}).catch(() => {
					this.$message.error('登录失败，请刷新页面重试')
				})
			},
			async initPage() {
				await this.getStudentList()
				this.startRefreshStatus()
				this.loading = false
			},
			async getCourseName() {
				try {
					const {
						data
					} = await this.API.get(this.API.school.getInfoById, {
						courseClassId: this.courseClassId
					})
					if (data.code === 200) {
						this.controlStudentPage = data.data.controlStudentPage
					}
				} catch (e) {}
			},
			async getStudentList() {
				try {
					const {
						data
					} = await this.API.get(this.API.school.getCreateStudentList, {
						schoolId: this.schoolId,
						courseClassId: this.courseClassId
					});
					this.studentList = data.data.studentList || []
					this.totalData = data.data.total || {}
					this.studentList.sort((a, b) => b.status - a.status)

				} catch (e) {}
			},

			startRefreshStatus() {
				if (this.statusTimer) clearInterval(this.statusTimer)
				this.statusTimer = setInterval(() => this.getStudentList(), 3000)
			},
			async selectStudent(student) {
				
			},
			async selectStudent(student) {
				this.currentStudentId = student.studentId
				if(this.customPageId==1){
					this.$refs.studentInde.switchTab()
				}
				this.currentStudentName = student.studentName
			},
			formatTime(t) {
				if (!t) return ''
				const d = new Date(t)
				return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,0)}-${String(d.getDate()).padStart(2,0)} ${String(d.getHours()).padStart(2,0)}:${String(d.getMinutes()).padStart(2,0)}`
			}
		}
	}
</script>

<style scoped>
	/* 样式和你原版完全一致 */
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	::-webkit-scrollbar-thumb {
		border-radius: 4px;
		background: #ccc;
	}

	.top-bar h3 {
		font-size: 20px;
		font-weight: bold;
	}

	.chat-title {
		font-size: 20px;
		font-weight: bold;
	}

	.msg-item {
		display: flex;
		margin: 20px 0;
		max-width: 90%;
	}

	.msg-item.student,
	.msg-item.ai {
		margin-right: auto;
		flex-direction: row;
	}

	.msg-item.teacher {
		margin-left: auto;
		flex-direction: row-reverse;
	}

	.avatar {
		font-size: 30px;
		margin: 0 20px;
	}

	.msg-content {
		background: #f1f1f1;
		padding: 18px 24px;
		border-radius: 20px;
		font-size: 18px;
		box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
	}

	.msg-item.student .msg-content {
		background: #2d8cf0;
		color: #fff;
	}

	.msg-item.ai .msg-content {
		background: #67C23A;
		color: #fff;
	}

	.msg-item.teacher .msg-content {
		background: #ff7d00;
		color: #fff;
	}

	.show-on-mobile {
		display: none !important;
	}

	@media (max-width: 1024px) {
		.left-sidebar {
			display: none !important;
		}

		.show-on-mobile {
			display: inline-block !important;
		}
	}
</style>